var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTimePicker',_vm._g(_vm._b({attrs:{"use12-hours":_vm.use12Hours,"format":_vm.timeFormat}},'MTimePicker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }